import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { styled } from '@mui/material/styles';

const StyledLexicalContentEditableWrapper = styled('div')(({ theme }) => ({
  '.ContentEditable__root': {
    border: 0,
    fontSize: theme.typography.pxToRem(14),
    position: 'relative',
    outline: 0,
    padding: '24px',
    minHeight: '150px',
    listStyleType: 'disc',
  },
}));
export const LexicalContentEditable = ({ className }: { className?: string }): JSX.Element => {
  return (
    <StyledLexicalContentEditableWrapper>
      <ContentEditable className={className || 'ContentEditable__root'} />
    </StyledLexicalContentEditableWrapper>
  );
};
